export default function useCapitalize(string) {
  return string.replace(/\b(\w)/g, s => s.toUpperCase());
}